import React from "react";
import { BetaChannelTemplate } from "themes/administration/app-release/components";

function BetaChannel(props) {
    return <BetaChannelTemplate {...props} />;
}

export default BetaChannel;
